import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">Created By <b><a href="https://techconnect.com.au" target="_blank">TechConnect</a></b> 2019</span>
  `,
})
export class FooterComponent {
}
